<template>
  <v-select
    :value="value"
    :items="headers"
    item-text="text"
    :label="label"
    multiple
    outlined
    dense
    hide-details
    return-object
    class="vms-column-visibility"
    @change="onChange"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index < 1" small>
        <span>{{ item.text }}</span>
      </v-chip>
      <span v-if="index === 1" class="grey--text caption">
        (+{{ (value || []).length - 1 }})
      </span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "VmsColumnVisibility",
  props: {
    value: { type: Array, default: () => [] },
    headers: { type: Array, required: true },
    label: { type: String, default: "Columns" },
  },
  methods: {
    onChange(selected) {
      this.$emit("input", selected);
      this.$emit("change", selected);
    },
  },
};
</script>

<style scoped>
.vms-column-visibility {
  min-width: 160px;
  max-width: 220px;
}
</style>
